import { useCallback } from 'react';

import { useCRMEventsContext } from 'state/crm-events';
import { useLocale } from 'state/intl';
import { useLDContext } from 'state/launchdarkly';
import { changeUser, enableBrazeSdk, setEmail, wipeBrazeData } from 'utils/braze';
import { brand, env } from 'utils/environment';

import { UserDetails } from './types';

export const useThirdPartyAuthentication = () => {
  const { region } = useLocale();
  const { login: launchDarklyLogin, logout: launchDarklyLogout } = useLDContext();
  const { loginCRM, logoutCRM } = useCRMEventsContext();

  const logUserInToThirdPartyServices = useCallback(
    (currentUser: UserDetails) => {
      launchDarklyLogin(currentUser);

      loginCRM({
        customerId: currentUser.cognitoId,
        rbiCognitoId: currentUser.cognitoId,
        ...currentUser.details,
        brand: brand().toUpperCase(),
        region,
        env: env() as string,
      });

      changeUser(currentUser.cognitoId);

      // Update Braze Email for the user
      setEmail(currentUser.details.email);
    },
    [launchDarklyLogin, loginCRM, region]
  );

  const logUserOutOfThirdPartyServices = useCallback(() => {
    launchDarklyLogout();
    logoutCRM();

    // The Braze documentation does not state this, but when calling Braze.wipeData()
    // The Braze SDK will be disabled permanently, at least on iOs.
    // Therefore, we need to call Braze.enableSDK()to re-enable the SDK.
    wipeBrazeData();
    enableBrazeSdk();
  }, [launchDarklyLogout, logoutCRM]);

  return { logUserInToThirdPartyServices, logUserOutOfThirdPartyServices };
};
